import { FC, useEffect, useState } from 'react'
import { Checkbox } from '@chakra-ui/react'

interface CheckboxConfirmProps {
  value: string
  isChecked?: boolean
  isDisabled?: boolean
  onChange?: (value: string, checked: boolean) => void
  style?: Record<string, any>
}

export const CheckboxConfirm: FC<CheckboxConfirmProps> = ({ value, isChecked, isDisabled = false, ...props }) => {
  const [checked, setChecked] = useState<boolean>(isChecked || false)

  useEffect(() => {
    if (isChecked) {
      setChecked(isChecked)
      props.onChange && props.onChange(value, !checked)
    }
  }, [isChecked])

  const toggleChecked = () => {
    setChecked(!checked)
  }

  const handleChange = () => {
    toggleChecked()
    props.onChange && props.onChange(value, !checked)
  }

  return (
    <>
      <Checkbox colorScheme="green" onChange={handleChange} isDisabled={isDisabled} isChecked={checked} />
    </>
  )
}
